import { useBreakpoint } from '@twisto/hooks'
import type { IconComponent } from '@twisto/icons'

import { useBannerContext } from '../../banner.context'

import * as styles from './banner-icon.styles'

type Props = {
  icon: IconComponent
  className?: string
}

export const BannerIcon = ({ icon, className }: Props) => {
  const { size, variant, hasAction } = useBannerContext()
  const isDesktop = useBreakpoint('smUp')

  const Icon = icon

  return (
    <div
      className={`${className} banner-icon-wrapper`}
      css={[
        styles.container,
        styles.containerOffset[size],
        hasAction && isDesktop && styles.containerSize,
        hasAction && isDesktop && styles.containerBackground[variant],
        styles.iconColor[variant],
      ]}
    >
      <Icon
        className="banner-icon"
        color="inherit"
        css={[styles.iconSize[size]]}
        size="inherit"
      />
    </div>
  )
}
